import * as React from 'react';

const Tournaments = () => {
    return (
        <div style={{
            height: '460px',
            paddingTop: '200px',
            textAlign: 'center',

        }}>
            <h1>Coming soon!</h1>
        </div>
    )
};

export default Tournaments;


// WEBPACK FOOTER //
// ./src/pages/Tournaments/Tournaments.tsx